export function optional(obj: any, ...keys: string[]) {
  let opt = obj
  while (keys.length && opt[keys[0]] !== undefined && opt[keys[0]] !== null) {
    const key = keys.shift()
    opt = opt[key]
  }
  return keys.length ? false : opt
}
